export const getters = {
  getEstados: (state) => state.estados,
  getEstados: (state) => state.estados,
};

export default {};
